import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { Radio } from '@coveord/plasma-mantine';
import { RHFRadioGroup } from './RHFRadioGroup.js';
export var RHFRadio = function RHFRadio(props) {
    return /*#__PURE__*/ _jsx(Radio, _object_spread({}, props));
};
RHFRadio.Group = RHFRadioGroup;

//# sourceMappingURL=RHFRadio.js.map